import { Heading, PageContainer, VStack } from '@/components/Atoms'
import { IntroductionDialog } from '@/components/IntroductionDialog'
import { useMe } from '@/hooks/queries/useMe'
import { INTRO_DIALOGS } from '@/stores/tutorials'
import { getUserGivenName } from '@repo/utils'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import OffRouteOrdersCard from './-components/OffRouteOrdersCard'
import PlacedVsExpectedOrdersBySourceCard from './-components/PlacedVsExpectedOrdersBySourceCard'
import TotalOrdersCard from './-components/TotalOrdersCard'

export const Route = createFileRoute('/_auth/_modules/_app/welcome/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: me } = useMe()
  const { t } = useTranslation(['welcome', 'common'])

  const messageForTimeOfDay = useMemo(() => {
    const hour = new Date().getHours()
    if (hour < 12) return 'greetings.morning'
    if (hour < 18) return 'greetings.afternoon'
    return 'greetings.evening'
  }, [])

  const greetingMessage = useMemo(() => {
    if (!me) return t('greetings.welcome')

    return t(messageForTimeOfDay, { name: getUserGivenName(me) })
  }, [messageForTimeOfDay, me, t])

  return (
    <>
      <IntroductionDialog
        dialogId={INTRO_DIALOGS.WELCOME}
        title={t('tutorials.dialog.title')}
        guideUrl="/"
      >
        {t('tutorials.dialog.description')}
      </IntroductionDialog>

      <PageContainer maxWidth="wide">
        <VStack gap="md" className="py-6">
          <Heading level={1} className="text-5xl font-medium">
            {greetingMessage}
          </Heading>
          <Heading level={4} tone="muted" className="max-w-[700px] text-balance font-normal">
            {t('greetings.description')}
          </Heading>
        </VStack>

        <TotalOrdersCard />

        <OffRouteOrdersCard />

        <PlacedVsExpectedOrdersBySourceCard />
      </PageContainer>
    </>
  )
}
